import { atom } from 'jotai';

import { ThumbnailType } from '../types/file';
import { PdfViewerMode, ZoomLevel } from '../types/viewer';

/** 뷰어 Layer(Download, ShareButton, ZoomButton, PageDrawerButton, PageMoveButton) 활성화 관련 Atom */
export const isDisableHelpersAtom = atom(false);

/** 현재 페이지 관련 값에 대한 Atom */
export const currentPageAtom = atom(1);

/** 뷰어 Size 관련 값에 대한 Atom */
export const pageWrapperSizeAtom = atom({ width: 0, height: 0 });

/** 뷰어 모드(mobile, desktop)을 구분하는 Atom */
export const pdfViewerModeAtom = atom<PdfViewerMode>('desktop');

/** 뷰어 interval 요청에 사용되는 이전 페이지 관련 Atom */
export const prevPageAtom = atom(1);

/** Page Drawer Open 관련 Atom */
export const isOpenDrawerAtom = atom(false);

/** 뷰어에서 첫 번째 이미지가 렌더링됐는지 판별하는 Atom */
export const isFirstPageImageLoadedAtom = atom(false);

/** 현재 MessageBox 값을 저장하는 Atom */
export const currentMessageBoxIdAtom = atom<null | number>(null);

/** 뷰어 Zoom 관련 Atom */
export const zoomLevelAtom = atom<ZoomLevel>(1);

/** 모바일 Page 이동할 때 보여지는 효과를 위한 Atom */
export const isLeftClickAtom = atom(false);
export const isRightClickAtom = atom(false);

/** 문의양식 Modal이 열러있는지에 관한 값
 * wheel(desktop), swipe(mobile)에 대한 이벤트를 막기 위한 Atom
 */
export const isCtaModalOpenAtom = atom(false);

/** Cta Button 애니메이션이 작동 되었는지 여부를 저장하는 Atom */
export const isAnimationPlayedAtom = atom<boolean>(false);

/** Bulk용 Thumbnail을 저장하고 렌더링하는 Atom */
export const thumbnailsAtom = atom<ThumbnailType[] | null>(null);

export const pageTimeAtom = atom<Record<string, number> | null>(null);

export const isLanguageDropdownOpenAtom = atom(false);
